import React, {useState, Fragment} from 'react'
import styled from '@emotion/styled';
import pocketLogoImage from './pocket-logo.svg';
import magnifyingGlassImage from './magnifying-glass.svg';
import magnifyingGlassImageMobile from './magnifying-glass--mobile.svg';
import closeImage from './close.svg';
import menuItems from './menuItems';
import { myList } from './menuItems';

// TODO, move these constants to a proper home
const FONT_GRAPHIK = '"Graphik Web", "Helvetica Neue", Helvetica, Arial, sans-serif';

const colorGray20 = '#D3D3D3';
const colorGray60 = '#919191';
const colorPine80 = '#007A73';
const colorBlack100 = '#000000';

const SM = 700;
const MD_MAIN = 946; // TODO double check with design if this breakpoint is needed
const HEADER_MAX_WIDTH = 1530;

const breakpoints = [{
  label: 'SM',
  width: SM,
}, {
  label: 'MD',
  width: MD_MAIN,
}];

// xxl is broken out to its own media query line because it used min-width
const mq = breakpoints.reduce((acc, bp) => ({...acc, [bp.label]: `@media (max-width: ${bp.width}px)`}), {});
const xxl = `@media (min-width: ${HEADER_MAX_WIDTH}px)`;

const PocketLogo = styled.span`
    background-image: url(${pocketLogoImage});
    background-repeat: no-repeat;
    display: block;
    width: 90px;
    height: 24px;
    margin-left: 10px;
    
    ${mq['SM']} {
      margin-left: 20px;
      width: 95px;
      height: 25px;
    }
`

const NoopAnchor = (props) => (
    <a {...props} onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      props.onClick();
      return false;
    }}>{props.children}</a>
)

const NavItemLink = styled(NoopAnchor)`
    &:hover {
      color: ${colorPine80};
    }
    color: ${colorGray60};
    text-decoration: none;
    padding: 5px 8px;
    margin: 0 8px;
    font-size: 14px;
    
`

const NavItemLinkSelected = styled(NavItemLink)`
  color: ${colorBlack100};
  font-weight: 600;
`

const NavItem = styled.li`
  margin: 0 0 20px;
  padding: 0;
  list-style-type: none;
  
  ${mq['SM']} {
    padding: 12px 0;
  }
  
  ${xxl} {
    &:first-of-type {
      a {
      margin-left: 0;
      padding-left: 0;
      }
    }
  }
`

const NavList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    height: 20px;
    overflow-y: hidden;
    margin: 0 0 0 16px;
    padding: 0;
    min-width: 95px;
    
    ${mq['SM']} {
      margin: 0;
      height: 40px;
      padding: 0 20px;
    }
`

const NavContainer = styled.div`
    display: flex;
    padding: 0;
    
    ${mq['SM']} {
      order: 3;
      border-top: solid 1px ${colorGray20};
      border-bottom: solid 1px ${colorGray20};
      width: 100%;
    }
    
    ${xxl} {
      padding: 0 0 0 100px;
    }
`

const ExploreHeader = styled.div`
    display: flex; align-items: center;
    max-width: ${HEADER_MAX_WIDTH}px;
    height: 60px;
    font-family: ${FONT_GRAPHIK};
    padding: 0 32px;
    margin: 0 auto;

    ${mq['SM']} {
      flex-wrap: wrap;
      height: 100px;
      padding: 0;
      margin: 10px 0 0;
      border-bottom: none;
    }
`

const ExploreContainer = styled.div`
  border-bottom: 1px solid rgb(224, 224, 224);
  background-color: #ffffff;
  position: sticky;
  top: 0;
  
  ${mq['SM']} {
    border-bottom: none
  }
`

const SearchContainer = styled.div`
  margin-left: 30px;
  justify-content: flex-end;
  flex: 1;
  display: flex;
  
  ${[mq['SM']]} {
    order: 2;
    padding-right: 20px;
    flex: 0 0 auto;
    margin-left: 6px;
  }
`

const DesktopSearchBar = styled.div`
  position: relative;
  
  ${[mq['SM']]} {
    display: none;
  }
`

const SearchInput = styled.input`
    color: #444;
    font-size: 12px;
    line-height: 20px;
    border-radius: 5px;
    border: 1px solid #ddd;
    outline: none;
    padding: 4px 10px 2px 30px;
    transition: width .15s ease-in-out;
    width: 136px;

    &:focus {
      width: 12rem;
    }
    
    ${[mq['SM']]} {
      &:focus {
        width: 10rem;
      }
    }
`

const MobileSearchInput = styled(SearchInput)`
  flex: 1;
  height: 34px;
  font-size: 14px;
  padding-left: 35px;
`

const SearchIcon = styled.div`
    mask-image: url(${magnifyingGlassImage});
    width: 14px;
    height: 14px;
    background-color: #828282;
    position: absolute;
    top: 7px;
    left: 9px;
`

const SearchIconInput = styled(SearchIcon)`
    width: 16px;
    height: 16px;
    top: 17px;
    left: 25px;
`

const MobileSearchIcon = styled(SearchIcon)`
  mask-image: url(${magnifyingGlassImageMobile});
  width: 24px;
  height: 24px;
  right: 0;
  left: auto;
  top: 15px;
  margin-right: 20px;
  display: none;
  
  &:hover {
    cursor: pointer;
  }
  
  ${[mq['SM']]} {
    display: block;
  }
`

const MobileCloseIcon = styled(MobileSearchIcon)`
  mask-image: url(${closeImage});
  width: 19px;
  height: 19px;
  position: relative;
  top: auto;
  bottom: auto;
  left: auto;
  right: auto;
  margin: 0 10px 0 20px;
`

const handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    const searchTerm = e.target.value;

    window.location.assign(`/explore/${searchTerm}?src=search`);
  }
}

const MyListItem = styled(NavItem)`
  margin: 0;
  display: flex;
  flex: 0 0 auto;
  
  a {
    padding-right: 0;
    margin-right: 0;
    display: inline-block;
    
    ${[mq['SM']]} {
    }
  }
  
  ${[mq['SM']]} {
    margin-right: 26px;
    flex: 1;
    justify-content: flex-end;
    
    &::after {
      content: ' |';
      color: ${colorGray60};
      font-size: 14px;
      padding-top: 4px;
      padding-left: 8px;
    }
  }
  
  ${xxl} {
    &:first-of-type {
      a {
      margin-left: 8px;
      padding-left: 8px;
      }
    }
  }
`

const MyList = ({onClick}) => (
    <MyListItem>
      <NavItemLink href="/" onClick={() => onClick(myList)}>{myList.label}</NavItemLink>
    </MyListItem>
)

const MobileSearchExpanded = styled.div`
  display: ${({showInput}) => showInput ? 'flex' : 'none'};
  background-color: #fff;
  height: 48px;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  padding: 0 15px;
  box-sizing: border-box;
  align-items: center;
`

export default ({selectedItem, onClick}) => {
  const [isSearchActive, setSearchActive] = useState(false);

  return (
      <ExploreContainer>
        <ExploreHeader>
          <a href="/"><PocketLogo/></a>
          <NavContainer>
            <NavList>
              {menuItems.map((mi) => (
                  <NavItem key={mi.label}>
                    {mi === selectedItem ?
                        <NavItemLinkSelected href={mi.url} onClick={() => onClick(mi)}>{mi.label}</NavItemLinkSelected>
                        : <NavItemLink href={mi.url} onClick={() => onClick(mi)}>{mi.label}</NavItemLink>
                    }
                  </NavItem>
              ))}
            </NavList>
          </NavContainer>
          <SearchContainer>
            <DesktopSearchBar showInput={isSearchActive}>
              <SearchIcon/>
              <SearchInput placeholder='Search Pocket' onKeyDown={(e) => handleKeyDown(e)}/>
            </DesktopSearchBar>
            <MobileSearchIcon onClick={() => setSearchActive(true)}/>
            <MobileSearchExpanded showInput={isSearchActive}>
              <SearchIconInput/>
              <MobileSearchInput placeholder='Search Pocket' onKeyDown={(e) => handleKeyDown(e)}/>
              <MobileCloseIcon onClick={() => setSearchActive(false)}/>
            </MobileSearchExpanded>
          </SearchContainer>
          <MyList onClick={onClick}/>
        </ExploreHeader>
      </ExploreContainer>
  )
};

